import React from "react";
import {
  Box,
  CircularProgress,
  Grid,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from "@material-ui/core";
import translate from "i18n/translate";
import Row from "./Row";
import CommonHeaders from "./CommonHeaders";
import { Typography } from "../../../../common";

const DistributorsTable = ({ distributors, pagination, loading, userType }) => {
  if (loading) {
    return (
      <Box display="flex" padding={4}>
        <CircularProgress />
      </Box>
    );
  }
  return distributors.rows.length ? (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <CommonHeaders type={userType} />
          </TableRow>
        </TableHead>
        <TableBody>
          {distributors.rows.map((row) => (
            <Row type={userType} key={row.key} row={row} />
          ))}
        </TableBody>
      </Table>
      {pagination && (
        <TablePagination
          rowsPerPageOptions={pagination.rowsPerPageOptions}
          component="div"
          count={pagination.total}
          rowsPerPage={pagination.limit}
          page={pagination.page}
          onPageChange={pagination.onPageChange}
          onRowsPerPageChange={pagination.onRowsPerPageChange}
          labelRowsPerPage={translate("common.rowsPerPage")}
        />
      )}
    </TableContainer>
  ) : (
    <Grid container justifyContent="center" spacing={2}>
      {/* TODO: move to component */}
      <Box padding={4}>
        <Typography variant="h3">
          {translate("distributors.noOperations")}
        </Typography>
      </Box>
    </Grid>
  );
};

export default DistributorsTable;
